import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Typography,
  Switch,
  FormControlLabel,
  Slider,
  Button
} from '@mui/material';
import Tool, { CrawlTool } from '../../../Shared-ui/Types/Tool';
import { isOnlyAlphabets, isOnlyAlphabetsNumbers } from '../../../Shared-ui/utils/Common/Common';
import { useDispatch } from 'react-redux';
import { StartLoading, StopLoading } from '../../../Shared-ui/Store/LoadingReducer/LoaderActions';
import BaseInstance from '../../../Services/AxiosInstance/BaseInstance';
import { TOOLKIT, TOOLS } from '../../../Services/Endpoint';
import { ShowError } from '../../../Shared-ui/Store/MessageReducer/MsgActions';
import { ToolsKitTypeEnum } from '../../../Shared-ui/Enum/ToolsEnum';

interface MycomponentProps {
  handleClose: () => void
  tool: CrawlTool | null
}

const Crawl4AITools: React.FC<MycomponentProps> = (props) => {
  const toolErrIntial = {
    name: { error: "", value: false },
    description: { error: "", value: false }
  }
  const toolInitial: CrawlTool = {
    name: '',
    description: '',
    type: 'toolkit',
    is_active: true,
    config: {
      max_length: 100,
      toolkit_type: ToolsKitTypeEnum.Crawl4AI,
    },

  }
  const [tools, setTools] = useState<CrawlTool>(toolInitial);
  const [toolsErr, setToolsErr] = useState(toolErrIntial);
  const dispatch = useDispatch()
  const [isEditing, setIsEditing] = useState(false)



  useEffect(() => {
    if (props.tool) {
      setTools(props.tool)
      setIsEditing(true)
    }
  }, [])


  const handleCreateTool = async () => {
    if (!validateTool()) return
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(TOOLKIT, tools).then(
        (res) => res?.data
      );
      handleCancel()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }


  }


  const handleupdateTool = async () => {
    if (!validateTool()) return
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.put(`${TOOLS}/${tools.id}`, tools).then(
        (res) => res?.data
      );
      handleCancel()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }


  }


  const handleCancel = () => {
    setTools(toolInitial)
    props.handleClose()
  }


  const validateTool = () => {
    var error = 0

    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setToolsErr(prev => ({
          ...prev,
          [field]: { error: message, value: true }
        }));
        error += 1;
      } else {
        setToolsErr(prev => ({
          ...prev,
          [field]: { error: "", value: false }
        }));
      }
    };

    setError("name", (!tools.name.trim() || !isOnlyAlphabetsNumbers(tools.name.trim())), "Please enter the name A-z");
    setError("description", !tools.description.trim(), "Please enter the description A-z")

    return error > 0 ? false : true
  }


  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setTools(preVal => ({ ...preVal, [name]: value }))
  };

  const handleConfigChange = (value: any) => {
    setTools(preVal => ({
      ...preVal, config: {
        ...preVal.config,
        max_length: value
      },
    }))


  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl fullWidth error={toolsErr.name.value}>
        <TextField
          label="Tool Name"
          name="name"
          value={tools.name}
          onChange={handleChange}
          variant="outlined"
          error={toolsErr.name.value}
          helperText={toolsErr.name.error}
        />
      </FormControl>

      <FormControl fullWidth error={toolsErr.description.value}>
        <TextField
          label="Description"
          value={tools.description}
          onChange={handleChange}
          name="description"
          variant="outlined"
          multiline
          rows={3}
          error={toolsErr.description.value}
          helperText={toolsErr.description.error}
        />
      </FormControl>
      <Typography variant="body1" gutterBottom>
        Configuration for Crawl4AI
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Typography gutterBottom>Maximum Content Length</Typography>
        <Slider
          value={tools?.config?.max_length}
          name="max_length"
          onChange={(_, value) => handleConfigChange(value)}
          min={100}
          max={5000}
          step={100}
          marks
          valueLabelDisplay="auto"
          aria-labelledby="max-length-slider"
        />
        <FormHelperText>
          Maximum number of characters to extract from each webpage
        </FormHelperText>
      </Box>

      <FormControlLabel
        control={
          <Switch
            checked={tools.is_active}
            name='is_active'
            onChange={(e) => setTools(preVal => ({ ...preVal, [e.target.name]: e.target.checked }))}
          />
        }
        label="Active"
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mb: 3
        }}
      >
        <Button
          variant="outlined"
          size="large"
          sx={{ textTransform: "capitalize" }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          size="large"
          sx={{ textTransform: "capitalize" }}
          onClick={() => isEditing ? handleupdateTool() : handleCreateTool()}
        >
          {isEditing ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default Crawl4AITools;